import productApi from "api/ProductApi";
import {
  FETCH_DETAIL_PRODUCT_SUCCESS,
  FETCH_LIST_PRODUCT_SUCCESS,
  FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS,
  FETCH_LIST_PRODUCT_NEW_SUCCESS,
} from "redux/ActionTypes/ProductActionTypes";
import { activeProgress, disableProgress } from "./ProgressActionCreators";
import ToastCustom from "shared/components/ToastCustom";

export const fetchPaginationProductRequest = (
  index,
  size,
  valueSearch,
  keySort,
  idCategory,
  idSale
) => {
  return (dispatch) => {
    dispatch(activeProgress());

    return productApi
      .paginate(size, index, valueSearch, keySort, idCategory, idSale)
      .then(
        (res) => {
          dispatch(fetchListProductSuccess(res.body));
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDetailProductRequest = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .getDetail(id)
      .then(
        (res) => {
          dispatch(fetchDetailProductSuccess(res.body));
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchListProductRecommendRequest = (idCategory, count) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .getProductRecommends(idCategory, count)
      .then(
        (res) => {
          dispatch(fetchListProductRecommendSuccess(res.body));
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchListProductNewRequest = (count) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .getProductNews(count)
      .then(
        (res) => {
          dispatch(fetchListProductNewSuccess(res.body));
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDeleteProductRequest = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .delete(id)
      .then(
        (res) => {
          ToastCustom.success("Xóa Thành Công");
        },
        (err) => {
          console.log(err);
          ToastCustom.error("Xóa Thất bại");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchCreateProductRequest = (data) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .create(data)
      .then(
        (res) => {
          ToastCustom.success("Thêm Sản Phẩm Thành Công");
        },
        (err) => {
          console.log(err);
          ToastCustom.error("Thêm Sản Phẩm Thất bại");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchPutPromotionToProductRequest = (idProducts, idPromotion) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return productApi
      .upToPromotion(idProducts, idPromotion)
      .then(
        (res) => {
          ToastCustom.success("Thêm sale Thành Công");
        },
        (err) => {
          console.log(err);
          ToastCustom.error("Thêm sale Thất bại");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDetailProductSuccess = (data) => {
  return {
    type: FETCH_DETAIL_PRODUCT_SUCCESS,
    payload: data,
  };
};

export const fetchListProductSuccess = (data) => {
  return {
    type: FETCH_LIST_PRODUCT_SUCCESS,
    payload: data,
  };
};

export const fetchListProductRecommendSuccess = (data) => {
  return {
    type: FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS,
    payload: data,
  };
};

export const fetchListProductNewSuccess = (data) => {
  return {
    type: FETCH_LIST_PRODUCT_NEW_SUCCESS,
    payload: data,
  };
};
